module.exports = __webpack_public_path__ + "static/media/Henrik-Pettersson-Brainz-Cover.4227bad1.jpg";